import { RootState } from '@reducers';

export const selectGarageNetworkPage = (state: RootState) => state.garageNetworkPageReducer;
